import React from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import axios from 'axios';
import LocalizedStrings from 'react-localization';
import localeFile from '../../local/content';
import {connect} from 'react-redux';
const strings = new LocalizedStrings(localeFile);

class MainBanner extends React.Component {
    state = {
        isOpen: false
    };

    openModal = () => {
        this.setState({isOpen: true})
    }
    constructor(props) {
        super(props)
        this.state = {
            posts: []
          };

    }
    componentDidMount(){
        axios.get(`https://admin.futurevisions.tn/api/get_about`)
          .then(res => {
            const posts = res.data.about[0];
            this.setState({ posts });
   
          })
      }
    render(){
        strings.setLanguage(this.props.languageCode);
        return (
            <React.Fragment>
                <ModalVideo 
                    channel='youtube' 
                    isOpen={this.state.isOpen} 
                    videoId={this.state.posts.video_presentation} 
                    onClose={() => this.setState({isOpen: false})} 
                />

                <div className="main-banner item-bg2">
                    <div className="d-table">
                        <div className="d-table-cell">
                            <div className="container">
                                <div className="main-banner-content banner-content-center">
                                    {/* <p>Are you <span>ready</span> to attend?</p> */}
                                    <h1>    <span>{strings.hreflangCode=='fr'?  this.state.posts.big_title : this.state.posts.big_title_arabe}</span> <br />
                                      {/* <b>2</b><b>0</b><b>2</b><b>3</b> */}
                                      </h1>
                                    <ul>
                                        {/* <li><i className="icofont-compass"></i> Yellow Street, United State</li> */}
                                        {/* <li><i className="icofont-calendar"></i> 23-27 Jan, 2020</li> */}
                                    </ul>
                                    <div className="button-box">
                                        {/* <Link to="#" className="btn btn-primary">Buy Tickets Now!</Link> */}
                                        <Link 
                                            onClick={e => {e.preventDefault(); this.openModal()}}
                                            to="#" 
                                            className="video-btn popup-youtube"
                                        >
                                            <i className="icofont-ui-play"></i> {strings.regarderz_video_promo}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
    
                    <div className="shape1">
                        <img src={require("../../assets/images/shapes/1.png")} alt="shape1" />
                    </div>
                    <div className="shape2 rotateme">
                        <img src={require("../../assets/images/shapes/2.png")} alt="shape2" />
                    </div>
                    <div className="shape3 rotateme">
                    </div>
                    <div className="shape4">
                        <img src={require("../../assets/images/shapes/4.png")} alt="shape4" />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => {
    return {
      languageCode: state.languageCode
    }
  }

export default connect(mapStateToProps)(MainBanner);